import { Tabs as TabsPrimitive } from 'radix-ui'
import type { ComponentProps } from 'react'
import { cn } from '../lib/cn'

/**
 * Abas em fio inferior, nunca em pílula. Aba ativa: Lexend com fio ink embaixo.
 * Cada aba trata de um assunto só; aba sem conteúdo mostra o estado vazio dela.
 */

export function Tabs({ className, ...props }: ComponentProps<typeof TabsPrimitive.Root>) {
  return (
    <TabsPrimitive.Root data-slot="tabs" className={cn('flex flex-col', className)} {...props} />
  )
}

export function TabsList({ className, ...props }: ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        'border-hairline max-desk:gap-5 flex gap-6 overflow-x-auto border-b',
        className,
      )}
      {...props}
    />
  )
}

export function TabsTrigger({ className, ...props }: ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        'font-body text-secondary hover:text-ink -mb-px cursor-pointer border-b border-transparent pb-[10px] text-[13px] leading-none font-light whitespace-nowrap transition-[color,border-color]',
        'data-[state=active]:border-ink data-[state=active]:font-display data-[state=active]:text-ink data-[state=active]:font-normal',
        className,
      )}
      {...props}
    />
  )
}

export function TabsContent({ className, ...props }: ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn('pt-6 outline-none', className)}
      {...props}
    />
  )
}
